import { Game, GameKind, QuickRankConfiguration, RankifierConfiguration, SwiperConfiguration } from "../../gql/graphql";

export type CardBasedGame = Omit<Game, "configuration"> & {
  configuration: QuickRankConfiguration | RankifierConfiguration | SwiperConfiguration;
};

export function isCardBasedGame(game: Game): game is CardBasedGame {
  return game.kind === GameKind.QuickRank || game.kind === GameKind.Rankifier || game.kind === GameKind.Swiper;
}
